<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/equipment/model/num/time/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" type="equipment" :ids.sync="yt.conditions.equipmentIds"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('jiqichanliangcaijishijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.currentProductStartTime" :end.sync="yt.conditions.currentProductEndTime"></yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <template #zhouqi(s)="scope">
        <span>{{ millToSeconds(scope.row.cycleTime) }}</span>
      </template>
      <template #yunxingshijian(s)="scope">
        <span>{{ millToSeconds(scope.row.runTime) }}</span>
      </template>
      <template #rengongshijian(s)="scope">
        <span>{{ millToSeconds(scope.row.manualTime) }}</span>
      </template>
      <template #guzhangshijian(s)="scope">
        <span>{{ millToSeconds(scope.row.faultTime) }}</span>
      </template>
      <template #guzhang="scope">
        <span>{{ scope.row.fault ? $t('shi') : $t('fou') }}</span>
      </template>

      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_equipment_model_num_time_list',
  data() {
    return {
      columns: [
        {
          label: 'shebeimingcheng',
          prop: 'equipmentInfo.name'
        },
        {
          label: 'zhouqi(s)',
          prop: 'cycleTime',
          type: 'slot'
        },
        {
          label: 'yunxingshijian(s)',
          prop: 'runTime',
          type: 'slot'
        },
        {
          label: 'rengongshijian(s)',
          prop: 'manualTime',
          type: 'slot'
        },
        {
          label: 'guzhangshijian(s)',
          prop: 'faultTime',
          type: 'slot'
        },
        {
          label: 'jiqichanliang',
          prop: 'currentProduct'
        },
        {
          label: 'jiqichanliangcaijishijian',
          prop: 'currentProductTime',
          type: 'time'
        },
        {
          label: 'leijikaihemocishu',
          prop: 'totalMould'
        },
        {
          label: 'dangqianmoci',
          prop: 'currentMould'
        },
        // {
        //   label: 'fuweicishu',
        //   prop: 'resetTimes'
        // },
        {
          label: 'guangmubeizhecishu',
          prop: 'obscuredTimes'
        },
        {
          label: 'guzhang',
          prop: 'fault',
          type: 'slot'
        },
        {
          label: 'caozuomoshi',
          prop: 'operationMode',
          type: 'dictionary',
          key: 'OPERATION_MODE'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
    }, 300);
  },
  methods: {
    // 毫秒转秒
    millToSeconds(mill) {
      if (!mill) {
        return 0;
      }
      return (mill / 1000).toFixed(1);
    }
  }
};
</script>
